'use strict';

/* global document:false, window:false */
const ready = fn => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    // https://developer.mozilla.org/en-US/docs/Web/Events/DOMContentLoaded
    document.addEventListener('DOMContentLoaded', fn);
  }
};

ready(() => {
  document
    .querySelectorAll(
      '#subscribe_banner_container, #subscribe_modal_container, #two_step_div'
    )
    .forEach(element => {
      element.querySelectorAll('[href="/login"]').forEach(elem => {
        elem.addEventListener('click', () => {
          let path, queryString;
          if (!window.location.search) {
            queryString = `?ref=${encodeURIComponent(
              window.location.pathname
            )}`;
          } else {
            path = encodeURIComponent(`${window.location.pathname}?`);
            queryString = `?ref=${path}${window.location.search.substr(1)}`;
          }
          elem.setAttribute(
            'href',
            `${elem.getAttribute('href')}${queryString}`
          );
        });
      });
    });
});
